module.exports = __webpack_public_path__ + "static/media/young-agronomist-analyzing-field-with-farmer-indian-farming.0e0e7ffd.jpg";